import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { LayoutHome } from './components/LayoutHome';
import { Switch } from 'react-router-dom';
import { Home } from './components/HomePage';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';

import { TrainingSelectionPage } from './components/TrainingSelectionPage';
import { TrainingStartExamPage } from './components/TrainingStartExamPage';
import { TrainingDetailPage } from './components/TrainingDetailPage';
import { TrainingExamPage } from './components/TrainingExamPage';
import { TrainingExamResultPage } from './components/TrainingExamResultPage';
import { NotFoundPage } from './components/NotFoundPage';

export default class App extends Component {
  static displayName = App.name;

    render() {

        var logo = "logisticworkx.png";
        var title = "Logistic Workx";

      return (

        <div className="Site">
            <div className="Site-content">

                <Switch>
                    <Route exact path={[
                          "/training",
                          "/training/:id",
                          "/vrtraining/:id",
                          "/training/:id/start",
                          "/training/:id/exam",
                          "/trainingresult/:id",
                      ]}>
                        <Layout>
                            <Switch>
                                <AuthorizeRoute exact path='/training' component={TrainingSelectionPage} />
                                <AuthorizeRoute exact path='/training/:id' component={TrainingDetailPage} />
                                <AuthorizeRoute exact path='/training/:id/start' component={TrainingStartExamPage} />

                                <AuthorizeRoute exact path='/training/:id/exam' component={TrainingExamPage} />
                                <AuthorizeRoute exact path='/trainingresult/:id' component={TrainingExamResultPage} />
                            </Switch>
                        </Layout>
                      </Route>

                      <Route path={ ApplicationPaths.ApiAuthorizationPrefix } >
                          <Layout>
                              <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
                          </Layout>
                      </Route>

                      <Route exact path={["/lw", "/cw", "/"]}>
                          <LayoutHome>
                              <Switch>
                                  <Route exact path='/' component={Home} />

                                  <Route component={NotFoundPage} />
                              </Switch>
                          </LayoutHome>
                      </Route>

                      <Route path={ "/" }>
                          <Layout>
                              <Route component={NotFoundPage} />
                          </Layout>
                      </Route>
                </Switch>
            </div>

            <footer className="border-top footer text-muted py-1">
                <div className="container text-center py-3">
                    &copy; 2023 - {title}
                </div>
            </footer>
        </div>
    );
  }
}
